import { render } from "./ChangeInstanceType.vue?vue&type=template&id=31debe46"
import script from "./ChangeInstanceType.vue?vue&type=script&lang=js"
export * from "./ChangeInstanceType.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__